module.exports = __webpack_public_path__ + "img/samsung-fridge.138229b8.jpg";